import { render } from "./user-report.vue?vue&type=template&id=15489c55"
import script from "./user-report.vue?vue&type=script&lang=js"
export * from "./user-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__